<template>
    <div
        v-if="visible"
        class="modal items-center"
        :class="{ 'modal-open': visible }"
    >
        <div class="modal-box p-3.5 xs:p-4 pb-0 xs:pb-0 rounded w-[85%] max-w-[40rem]">
            <TermsFrame
                needLayer
                height="h-[28vh] md:h-[28vh]"
                needGuideArrow
                :title="title"
                :content="content"
                :need-checkbox="true"
                :checkboxCenter="true"
                checkboxText="本人已充分閱讀且同意"
                @isAgree="isAgree"
            />
            <div class="text-center mb-8">
                <button
                    class="btn gradient-primary rounded-full py-3 px-5"
                    :disabled="!agree || isLoading"
                    @click="agreePersonalInformation"
                >
                    {{ isLoading ? '載入中，請稍後' : '確定' }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, toRefs, watch, ref } from 'vue';
import TermsFrame from '@/components/template/TermsFrame.vue';
import { getGetPersonalInformation, postAgreePersonalInformation, postUpdateAgreePersonalInformation } from '@/apis/agreeTerms';

export default {
    components: {
        TermsFrame,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        uuid: {
            type: String,
            default: '',
        },
        canUpdate: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        source: {
            type: String,
            default: '',
        },
        token: {
            type: String,
            default: '',
        }
    },
    emits: ['clickBtn', 'update:uuid'],
    setup(props, { emit }) {
        const data = reactive({
            content: '',
            title: '',
            isLoading: false,
        });
        const agree = ref(false);
        const isAgree = (a) => {
            agree.value = a;
        };
        const getPersonalInformation = () => {
            getGetPersonalInformation().then((res) => {
                data.content = res.data.agreeTerms.content;
                data.title = res.data.agreeTerms.title;
            });
        };

        const agreePersonalInformation = () => {
            data.isLoading = true;
            const request = {
                id: props.id,
                source: props.source,
                token: props.token,
            };

            postAgreePersonalInformation(request).then((res) => {
                emit('update:uuid', res.data.uuid);
                emit('clickBtn');
            }).finally(() => {
                data.isLoading = false;
            });
        };

        watch(() => props.visible, (nV) => {
            if (nV) {
                getPersonalInformation();
            }
        }, { immediate: true });

        watch(() => props.canUpdate, (nV) => {
            if (nV) {
                const request = {
                    uuid: props.uuid,
                    source: props.source,
                };
                postUpdateAgreePersonalInformation(request).then((res) => {
                });
            }
        }, { immediate: true });

        return {
            ...toRefs(data),
            isAgree,
            agree,
            agreePersonalInformation,
        };
    },
};
</script>
